import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-b96c9d34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "rank_contain" }
const _hoisted_3 = { class: "title public_flex_center" }
const _hoisted_4 = { class: "bg public_flex_center" }
const _hoisted_5 = { class: "up public_flex_center" }
const _hoisted_6 = { class: "swiper_box public_flex_center" }
const _hoisted_7 = { class: "slide_item" }
const _hoisted_8 = { class: "gift_bg" }
const _hoisted_9 = { class: "img public_flex_center" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "name public_flex_center" }
const _hoisted_12 = { class: "rank_contain" }
const _hoisted_13 = { class: "title public_flex_center" }
const _hoisted_14 = { class: "bg public_flex_center" }
const _hoisted_15 = { class: "up public_flex_center" }
const _hoisted_16 = { class: "course_wrap" }
const _hoisted_17 = { class: "course_title public_flex_center" }
const _hoisted_18 = { class: "round_wrap" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow1" }, null, -1 /* HOISTED */))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow2" }, null, -1 /* HOISTED */))
const _hoisted_21 = { class: "round_list public_flex_start" }
const _hoisted_22 = { class: "round_item" }
const _hoisted_23 = { class: "round_name" }
const _hoisted_24 = { class: "round_name" }
const _hoisted_25 = { class: "round_time" }
const _hoisted_26 = { class: "tip" }
const _hoisted_27 = {
  key: 0,
  class: "course_wrap course_wrap2"
}
const _hoisted_28 = { class: "course_title public_flex_center" }
const _hoisted_29 = { class: "round_wrap" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow1" }, null, -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow2" }, null, -1 /* HOISTED */))
const _hoisted_32 = {
  key: 0,
  class: "round_item"
}
const _hoisted_33 = { class: "round_name" }
const _hoisted_34 = { class: "round_time" }
const _hoisted_35 = { class: "tip" }
const _hoisted_36 = {
  key: 1,
  class: "course_wrap course_wrap3"
}
const _hoisted_37 = { class: "course_title public_flex_center" }
const _hoisted_38 = { class: "round_wrap" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow1" }, null, -1 /* HOISTED */))
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shadow shadow2" }, null, -1 /* HOISTED */))
const _hoisted_41 = { class: "round_list public_flex_center" }
const _hoisted_42 = { class: "round_name" }
const _hoisted_43 = { class: "round_name" }
const _hoisted_44 = { class: "round_time" }
const _hoisted_45 = { class: "tip" }
const _hoisted_46 = { class: "rank_contain" }
const _hoisted_47 = { class: "title public_flex_center" }
const _hoisted_48 = { class: "bg public_flex_center" }
const _hoisted_49 = { class: "up public_flex_center" }
const _hoisted_50 = { class: "course_wrap course_wrap4" }
const _hoisted_51 = { class: "course_title public_flex_center" }
const _hoisted_52 = { class: "tip tip4 public_flex_center" }
const _hoisted_53 = { class: "course_swiper_wrap public_flex_center" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "course_shadow course_shadow1" }, null, -1 /* HOISTED */))
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "course_shadow course_shadow2" }, null, -1 /* HOISTED */))
const _hoisted_56 = { class: "slide_item" }
const _hoisted_57 = { class: "gift_bg" }
const _hoisted_58 = { class: "img public_flex_center" }
const _hoisted_59 = ["src"]
const _hoisted_60 = { class: "name public_flex_center" }
const _hoisted_61 = { class: "text" }
const _hoisted_62 = {
  key: 1,
  class: "swiper_box public_flex_center"
}
const _hoisted_63 = { class: "slide_item" }
const _hoisted_64 = { class: "gift_bg" }
const _hoisted_65 = { class: "img public_flex_center" }
const _hoisted_66 = ["src"]
const _hoisted_67 = { class: "name public_flex_center" }
const _hoisted_68 = { class: "text" }
const _hoisted_69 = { class: "course_wrap course_wrap5" }
const _hoisted_70 = { class: "course_title public_flex_center" }
const _hoisted_71 = { class: "course_swiper_wrap public_flex_center" }
const _hoisted_72 = { class: "hour_icon" }
const _hoisted_73 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "num" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg public_flex_center" }, "????"),
  /*#__PURE__*/_createElementVNode("div", { class: "up public_flex_center" }, "????")
], -1 /* HOISTED */))
const _hoisted_74 = { class: "num" }
const _hoisted_75 = { class: "bg public_flex_center" }
const _hoisted_76 = { class: "up public_flex_center" }
const _hoisted_77 = { class: "text" }
const _hoisted_78 = { class: "rank_contain" }
const _hoisted_79 = { class: "title public_flex_center" }
const _hoisted_80 = { class: "bg public_flex_center" }
const _hoisted_81 = { class: "up public_flex_center" }
const _hoisted_82 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "user_play" }, null, -1 /* HOISTED */))
const _hoisted_83 = { class: "play_tip" }

import { computed, ref } from 'vue';
import listBg from './components/listBg.vue';
import carousel from '@activity-business/h5-package-carousel';
import { rewardTypeName } from '../PreludeRank/utils/type';
import NoticeBar from './components/NoticeBar.vue';
import injectTool from './utils/injectTool';


export default /*#__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

const {TOOL_countryCode} = injectTool();

// 获取用户大区
const userArea = ref<string>(TOOL_countryCode);
// 区域赛主赛程
const mainSchedule = computed(() => {
    const jinji = {
        'EG': [800, 200, 10, 210, 500],
        'ME': [800, 200, 10, 210, 500],
        'TR': [500, 180, 10, 190, 500],
        'IN': [400, 150, 10, 160, 500],
        'ID': [200, 100, 10, 110, 500],
        'US': [150, 60,  5,  65 , 500],
        'NA': [150, 60,  5,  65 , 500],
        'PH': [150, 60,  5,  65 , 500],
        'VN': [300, 80,  10, 90 , 500],
        'TW': [500, 150, 10, 160, 500],
        'TH': [200, 80,  5,  85 , 500],
        'MY': [200, 50,  5,  55 , 500],
        'JP': [100, 50,  5,  55 , 500],
        'DE': [80,  20,  5,  25 , 500],
        'FR': [80,  20,  5,  25 , 500],
        'BR': [80,  20,  5,  25 , 500],
    }

    return [
        {name:16,rank:17,time:55,rankNum:[jinji[userArea.value][0]]},
        {name:18,rank:19,time:56,rankNum:[jinji[userArea.value][0],jinji[userArea.value][1]]},
        {name:20,rank:17,time:57,rankNum:[jinji[userArea.value][2]]},
        {name:22,rank:23,time:58,rankNum:[]},
        {name:24,rank:17,time:59,rankNum:[jinji[userArea.value][4]]},
        {name:26,rank:27,time:60,rankNum:[]},
    ]
}) 

// 区域赛单项赛
const singleSchedule = computed(() => [
    {name:29,rank:17,time:61},
    {name:30,rank:19,time:62},
    {name:80,rank:17,time:63},
    {name:31,rank:23,time:64,},
    {name:32,rank:23,time:65,show:userArea.value!='JP'},
])

// 区域赛公会赛
const unionSchedule = computed(() => {
    if (['EG','TR','ME'].includes(TOOL_countryCode)) return [
        {name:37,rank:90,time:66,rankNum:[]},
        {name:38,rank:91,time:67,rankNum:[]},
        {name:39,rank:92,time:68,rankNum:[]},
    ]

    return [
        {name:36,rank:81,time:69,rankNum:[]},
    ]
})

// 礼物信息
const giftInfoList:any[] = [
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -9,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/ccca2c4cabc611ef941d0242c0a80004.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    },
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -10,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/e23561beabc611ef97d50242c0a80004.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    },
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -11,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/f545c4a6abc611ef8aaa0242c0a80004.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    },
    {
        "uid": null,
        "area": null,
        "activityId": 0,
        "reason": 0,
        "gender": 0,
        "grade": 0,
        "index": 0,
        "stage": 0,
        "goodId": -12,
        "type": -1,
        "count": 1,
        "duration": 1,
        "durationHour": 0,
        "image": "/media/2024/11/26/047a19ccabc711efafbb0242c0a80002.png",
        "webp": null,
        "mp4": null,
        "key": null,
        "addScore": 0,
        "scoreRate": 0.0,
        "chatType": 0,
        "price": 0,
        "saveFlag": false,
        "discount": null,
        "originalPrice": null,
        "groupNumber": null,
        "rewardScene": null,
        "subRewardScene": null
    }
];
// 奖励预览
const rewardList:any[] = [
    {
        "mp4": "",
        "image": "/media/2024/11/27/13f204ccac8b11ef879a0242c0a80004.png",
        "abbreviationImage": "",
        "price": "10",
        "dynamic": "",
        "id": 20001624,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/2c72009cac8b11ef98840242c0a80004.png",
        "abbreviationImage": "",
        "price": "2800",
        "dynamic": "",
        "id": 20001625,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/32a9b86aac8b11ef879a0242c0a80004.png",
        "abbreviationImage": "",
        "price": "26000",
        "dynamic": "",
        "id": 20001626,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/5236b6baac8b11ef873c0242c0a80004.png",
        "abbreviationImage": "",
        "price": "300000",
        "dynamic": "",
        "id": 20001628,
        "mp4Md5": ""
    },
    {
        "mp4": "",
        "image": "/media/2024/11/27/5841991cac8b11ef98840242c0a80004.png",
        "abbreviationImage": "",
        "price": "4999",
        "dynamic": "",
        "id": 20001634,
        "mp4Md5": ""
    }
];

// 分享页面中所有按钮点击事件都是此函数 打开app
const fnGoApp = () => {
    window.location.href = `https://sugo.onelink.me/gqNC/8d34d20a?source=invite`
}


return (_ctx: any,_cache: any) => {
  const _component_uiImg = _resolveComponent("uiImg")!
  const _directive_animate = _resolveDirective("animate")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" 年度top奖励 "),
    _createVNode(listBg, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.MIXIN_TEXT[3]), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.MIXIN_TEXT[3]), 1 /* TEXT */)
          ]),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(giftInfoList, (item, index) => {
              return _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("img", {
                      class: "gift_img",
                      src: 'https://oss-image.voicemaker.media/'+item.image
                    }, null, 8 /* PROPS */, _hoisted_10)
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(NoticeBar, {
                      class: "notice",
                      notice: _ctx.MIXIN_TEXT[_unref(rewardTypeName)[item.goodId]]
                    }, null, 8 /* PROPS */, ["notice"])
                  ])
                ])
              ])
            }), 64 /* STABLE_FRAGMENT */))
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "view_all public_flex_center",
            onClick: fnGoApp
          }, [
            _createTextVNode(_toDisplayString(_ctx.MIXIN_TEXT[54]), 1 /* TEXT */)
          ])), [
            [_directive_animate]
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" 赛程赛制 "),
    _createVNode(listBg, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.MIXIN_TEXT[13]), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.MIXIN_TEXT[13]), 1 /* TEXT */)
          ]),
          _createCommentVNode(" 主赛程 "),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("span", null, _toDisplayString(_ctx.MIXIN_TEXT[14]), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _hoisted_20,
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mainSchedule.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.MIXIN_TEXT[item.name]), 1 /* TEXT */),
                    _createElementVNode("div", _hoisted_24, [
                      (_ctx.MIXIN_TEXT[item.rank])
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (item.rankNum.length===2)
                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                  _createTextVNode(_toDisplayString(_ctx.MIXIN_TEXT[item.rank].replace('a%',item.rankNum[0]).replace('d%',item.rankNum[1])), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                  _createTextVNode(_toDisplayString(_ctx.MIXIN_TEXT[item.rank].replace('d%',item.rankNum[0])), 1 /* TEXT */)
                                ], 64 /* STABLE_FRAGMENT */))
                          ], 64 /* STABLE_FRAGMENT */))
                        : _createCommentVNode("v-if", true)
                    ]),
                    _createElementVNode("div", {
                      class: _normalizeClass(["line", ['line'+(index+1)]])
                    }, null, 2 /* CLASS */),
                    _createVNode(_component_uiImg, { n: "crown1" }),
                    _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.MIXIN_TEXT[item.time]), 1 /* TEXT */)
                  ]))
                }), 256 /* UNKEYED_FRAGMENT */))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.MIXIN_TEXT[15]), 1 /* TEXT */)
          ]),
          _createCommentVNode(" 区域单项赛 "),
          (_ctx.MIXIN_LANG !== 'BR')
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.MIXIN_TEXT[28]), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _hoisted_31,
                  _createElementVNode("div", {
                    class: _normalizeClass(["round_list", [!singleSchedule.value[4].show ? 'public_flex_center' : 'public_flex_start']])
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(singleSchedule.value, (item, index) => {
                      return (_openBlock(), _createElementBlock(_Fragment, null, [
                        (item.show===undefined||item.show===true)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.MIXIN_TEXT[item.name]), 1 /* TEXT */),
                              _createElementVNode("div", {
                                class: _normalizeClass(["line", ['line'+(index+1)]])
                              }, null, 2 /* CLASS */),
                              _createVNode(_component_uiImg, { n: "crown1" }),
                              _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.MIXIN_TEXT[item.time]), 1 /* TEXT */)
                            ]))
                          : _createCommentVNode("v-if", true)
                      ], 64 /* STABLE_FRAGMENT */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ], 2 /* CLASS */)
                ]),
                _createElementVNode("div", _hoisted_35, _toDisplayString(_ctx.MIXIN_TEXT[33]), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 区域公会赛 "),
          (!['JP','FR','DE','BR'].includes(_ctx.MIXIN_LANG))
            ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                _createElementVNode("div", _hoisted_37, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.MIXIN_TEXT[34]), 1 /* TEXT */)
                ]),
                _createElementVNode("div", _hoisted_38, [
                  _hoisted_39,
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(unionSchedule.value, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["round_item", {'round_item_single': unionSchedule.value.length===1}])
                      }, [
                        _createElementVNode("div", _hoisted_42, _toDisplayString(_ctx.MIXIN_TEXT[item.name]), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_43, [
                          (_ctx.MIXIN_TEXT[item.rank])
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (item.rankNum.length===2)
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      _createTextVNode(_toDisplayString(_ctx.MIXIN_TEXT[item.rank].replace('a%',item.rankNum[0]).replace('d%',item.rankNum[1])), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                      _createTextVNode(_toDisplayString(_ctx.MIXIN_TEXT[item.rank].replace('d%',item.rankNum[0])), 1 /* TEXT */)
                                    ], 64 /* STABLE_FRAGMENT */))
                              ], 64 /* STABLE_FRAGMENT */))
                            : _createCommentVNode("v-if", true)
                        ]),
                        _createElementVNode("div", {
                          class: _normalizeClass(["line", ['line'+(index+1)]])
                        }, null, 2 /* CLASS */),
                        _createVNode(_component_uiImg, { n: "crown1" }),
                        _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.MIXIN_TEXT[item.time]), 1 /* TEXT */)
                      ], 2 /* CLASS */))
                    }), 256 /* UNKEYED_FRAGMENT */))
                  ])
                ]),
                _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.MIXIN_TEXT[35]), 1 /* TEXT */)
              ]))
            : _createCommentVNode("v-if", true),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            class: "view_all public_flex_center",
            onClick: fnGoApp
          }, [
            _createTextVNode(_toDisplayString(_ctx.MIXIN_TEXT[54]), 1 /* TEXT */)
          ])), [
            [_directive_animate]
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" 榜单玩法 "),
    _createVNode(listBg, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.MIXIN_TEXT[40]), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.MIXIN_TEXT[40]), 1 /* TEXT */)
          ]),
          _createCommentVNode(" 活动礼物 "),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("span", null, _toDisplayString(_ctx.MIXIN_TEXT[41]), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.MIXIN_TEXT[42]), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_53, [
              (rewardList.length > 4)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_54,
                    _hoisted_55,
                    _createVNode(_unref(carousel), {
                      mode: 'singleSlide',
                      "swiper-config": {slidesPerView:4,allowTouchMove: true},
                      class: "swiper_box"
                    }, _createSlots({ _: 2 /* DYNAMIC */ }, [
                      _renderList(rewardList, (item, index) => {
                        return {
                          name: `slide${index+1}`,
                          fn: _withCtx(() => [
                            _createElementVNode("div", _hoisted_56, [
                              _createElementVNode("div", _hoisted_57, [
                                _createElementVNode("div", _hoisted_58, [
                                  _createElementVNode("img", {
                                    class: "gift_img",
                                    src: 'https://oss-image.voicemaker.media/'+item.image
                                  }, null, 8 /* PROPS */, _hoisted_59)
                                ]),
                                _createElementVNode("div", _hoisted_60, [
                                  _createVNode(NoticeBar, {
                                    class: "notice",
                                    notice: _ctx.MIXIN_TEXT[_unref(rewardTypeName)[item.id]]
                                  }, null, 8 /* PROPS */, ["notice"])
                                ]),
                                _createElementVNode("div", _hoisted_61, "+" + _toDisplayString(item.price), 1 /* TEXT */)
                              ])
                            ])
                          ])
                        }
                      })
                    ]), 1024 /* DYNAMIC_SLOTS */)
                  ], 64 /* STABLE_FRAGMENT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_62, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(rewardList, (item, index) => {
                      return _createElementVNode("div", _hoisted_63, [
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("img", {
                              class: "gift_img",
                              src: 'https://oss-image.voicemaker.media/'+item.image
                            }, null, 8 /* PROPS */, _hoisted_66)
                          ]),
                          _createElementVNode("div", _hoisted_67, [
                            _createVNode(NoticeBar, {
                              class: "notice",
                              notice: _ctx.MIXIN_TEXT[_unref(rewardTypeName)[item.id]]
                            }, null, 8 /* PROPS */, ["notice"])
                          ]),
                          _createElementVNode("div", _hoisted_68, "+" + _toDisplayString(item.price), 1 /* TEXT */)
                        ])
                      ])
                    }), 64 /* STABLE_FRAGMENT */))
                  ]))
            ])
          ]),
          _createCommentVNode(" 用户小时榜 "),
          _createElementVNode("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("span", null, _toDisplayString(_ctx.MIXIN_TEXT[43]), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_71, [
              _createElementVNode("div", _hoisted_72, [
                _hoisted_73,
                _createElementVNode("div", _hoisted_74, [
                  _createElementVNode("div", _hoisted_75, _toDisplayString(_ctx.MIXIN_TEXT[45]), 1 /* TEXT */),
                  _createElementVNode("div", _hoisted_76, _toDisplayString(_ctx.MIXIN_TEXT[45]), 1 /* TEXT */)
                ])
              ]),
              _createElementVNode("div", _hoisted_77, _toDisplayString(_ctx.MIXIN_TEXT[44]&&_ctx.MIXIN_TEXT[44].replace('xxxx', '????')), 1 /* TEXT */)
            ])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createCommentVNode(" 用户玩法 "),
    _createVNode(listBg, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_78, [
          _createElementVNode("div", _hoisted_79, [
            _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.MIXIN_TEXT[46]), 1 /* TEXT */),
            _createElementVNode("div", _hoisted_81, _toDisplayString(_ctx.MIXIN_TEXT[46]), 1 /* TEXT */)
          ]),
          _hoisted_82,
          _createElementVNode("div", _hoisted_83, _toDisplayString(_ctx.MIXIN_TEXT[47]), 1 /* TEXT */)
        ])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}
}

})